// Sorting Code Starts
const addSorting = filter=>{

    let newSort = [];
   newSort.push(
    {
        field: "relevance",
        order: "asc"
    },
     {
        field: "product_product_search_ranking_new_custom:float",
        order: "asc"
    },
   ),
   
    filter.sort = newSort
}
// Sorting Code Ends

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      console.log("WIZZY INIT");
      data.filters.configs.layout = "v1";
      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
        desktop: 2e3,
        mobile: 2e3,
      };
      return data;
    }
  );
  //Inventory source code start
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      payload.inventorySources = JSON.stringify([
        {
          key:
            typeof localStorage.store_id === "undefined"
              ? "SC_india"
              : localStorage.store_id,
          inStock: ["true", "false"],
        },
      ]);
      return payload;
    }
  );
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      payload.inventorySources = JSON.stringify([
        {
          key:
            typeof localStorage.store_id === "undefined"
              ? "SC_india"
              : localStorage.store_id,
          inStock: ["true", "false"],
        },
      ]);
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      payload.filters.inventorySources = [
        {
          key:
            typeof localStorage.store_id === "undefined"
              ? "SC_india"
              : localStorage.store_id,
          inStock: ["true", "false"],
        },
      ];
      return payload;
    }
  );
  //Inventory source code End

  // Sorting Code Starts
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      addSorting(data);
      return data;
    }
  );
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      if(data.sort&&data.sort.length&&data.sort[0].field=='relevance'){
        addSorting(data);
      }
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      if(data.filters.sort&&data.filters.sort.length&&data.filters.sort[0].field=='relevance'&&!(data.filters.type==="AUTOCOMPLETE_DEFAULT")&&!window.wizzyConfig.common.isOnCategoryPage)
      {
        addSorting(data.filters);
      }
      return data;
    }
  );
  // Sorting Code Ends
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
        
      //   $('body .opendropdown').click(function() {
      //     //console.log("inside");
      //     if ($('.opendropdown').hasClass("active")) {
      //        $('.opendropdown').removeClass('active');
      //       //$(".scope").removeClass('active');
      //       $(".scope").html('');
      //     }
      //     //console.log("hellllllll")
      //   const prodHandle = $(this).attr('data-handle');
      //   const clickedElement = $(this);
      //   $.get("/products/" + prodHandle + "/?view=variantpopup", function (data) {
      //     //console.log("data", data);
      //     clickedElement.next('.multivariant_container').html(data);
      //   });
      //   const $dropdown = $(this);
      //   const $parent = $dropdown.next('.multivariant_container');
      //     //console.log("$parent", $parent);
      //   if ($parent.length) {
      //     //alert("as");
      //       $parent.toggleClass('active');
      //      $dropdown.toggleClass('active');
      //       // const parentOffset = $parent.offset();
      //       // const dropdownOffset = $dropdown.offset();
      //       // const offsetTop = dropdownOffset.top - parentOffset.top;
      //       // const offsetLeft = dropdownOffset.left - parentOffset.left;
      //       //console.log($parent.offset(),'hi', $dropdown.offset());
      //       //$(".scope.horizontal-scope.active").css("top", offsetTop);
      //       //$(".scope.horizontal-scope.active").css("left", offsetLeft);
      //   }
        
      // });
      // var $el = $("body .product-dropdown");
      //   var $ee = $("body .scope");
      //   const $dropdown1 = $("body .opendropdown");
      //   $(document).on("click", function (e) {
      //     // Check if the clicked element is *outside* .product-dropdown and .opendropdown
      //     if (
      //       !$(e.target).closest(".product-dropdown").length &&
      //       !$(e.target).closest(".opendropdown").length &&
      //       !$(e.target).closest(".quick-add").length &&
      //       $ee.hasClass("active")
      //     ) {
      //       //console.log("if");
      //       $ee.removeClass("active");
      //       $ee.html("");
      //       $dropdown1.removeClass("active");
      //     }
      //   });
       // Delegate the click to prevent multiple bindings
  $('body').off('click', '.opendropdown').on('click', '.opendropdown', function (e) {
    e.stopPropagation(); // Prevent document click event from immediately closing it

    const $clickedDropdown = $(this);
    const $variantContainer = $clickedDropdown.next('.multivariant_container');

    // Close all other open dropdowns
    $('.opendropdown').not($clickedDropdown).removeClass('active');
    $('.multivariant_container').not($variantContainer).removeClass('active').html('');

    const prodHandle = $clickedDropdown.attr('data-handle');

    // Toggle active state for clicked dropdown
    $clickedDropdown.toggleClass('active');
    $variantContainer.toggleClass('active');

    if ($variantContainer.hasClass('active')) {
      // Load variant popup HTML via AJAX
      $.get(`/products/${prodHandle}/?view=variantpopup`, function (data) {
        $variantContainer.html(data);
      });
    } else {
      $variantContainer.html('');
    }
  });

  // Handle click outside to close any open dropdown
  $(document).off('click.variantpopup').on('click.variantpopup', function (e) {
    if (
      !$(e.target).closest('.product-dropdown').length &&
      !$(e.target).closest('.opendropdown').length &&
      !$(e.target).closest('.quick-add').length
    ) {
      $('.multivariant_container').removeClass('active').html('');
      $('.opendropdown').removeClass('active');
    }
  });
      const currentPath = window.location.pathname;
      const navLinks = document.querySelectorAll('nav.header__inline-menu .list-menu__item');
    
      let matchedNavItem = null;
    
      navLinks.forEach(link => {
        var tempLink = link.getAttribute("onclick").match(/'([^']+)'/)[1];
        if (tempLink === currentPath) {
          matchedNavItem = link;
        }
      });

      if (!matchedNavItem) {
        var tempChildLinks = document.querySelectorAll('nav.header__inline-menu .mega-menu__content .mega-menu__link.link');

        if (tempChildLinks) {
          tempChildLinks.forEach(link => {
            var tempLink = link.getAttribute("href");
            if (tempLink === currentPath) {
              matchedNavItem = link;
            }
          });
        }
      }

      if (matchedNavItem) {
        var parentNavItem = matchedNavItem.closest('details.mega-menu');
        if (parentNavItem) {
          var childNavItems = parentNavItem.querySelector('.mega-menu__content');
          if (childNavItems) {
            var categoryFilterWrapper = document.querySelector('.wizzy-facet-body.facet-body-product_main_category_custom');
            if (categoryFilterWrapper) {
              categoryFilterWrapper.innerHTML = childNavItems.innerHTML;
            }
          }
        }
      }

      // $('.wizzy-facet-list-block .mega-menu__link--level-2').click(function (e) {
      // e.preventDefault(); // Prevent link navigation

      // // Get the next sibling <ul class="list-unstyled">
      // var $submenu = $(this).next('.wizzy-facet-list-block .list-unstyled');

      // // Toggle visibility
      // $submenu.slideToggle('fast');

      // // Optional: close other open submenus (accordion behavior)
      // $('.wizzy-facet-list-block .mega-menu__link--level-2').not(this).next('.wizzy-facet-list-block .list-unstyled').slideUp('fast');
      // });
      $('.wizzy-facet-list-block .mega-menu__link--level-2').click(function (e) {
          e.preventDefault(); // Prevent link navigation

          // Get the next sibling <ul class="list-unstyled">
          var $submenu = $(this).next('.list-unstyled');

          // Toggle visibility
          $submenu.slideToggle('fast');

          // Optional: close other open submenus (accordion behavior)
          $('.wizzy-facet-list-block .mega-menu__link--level-2').not(this).next('.list-unstyled').slideUp('fast');
        });
      if (window.innerWidth > 768) {
        const sortWrapper = document.querySelector('.search-filters-top-wrapper .wizzy-search-sort-wrapper');
        if (sortWrapper) {
          const sortWrapperClone = sortWrapper.cloneNode(true);
          const sortInFiltersWrapper = document.querySelector('.wizzy-search-filters-left .wizzy-sort-desktop');
  
          if (sortWrapperClone && sortInFiltersWrapper) {
            sortInFiltersWrapper.innerHTML = "";
            sortInFiltersWrapper.appendChild(sortWrapperClone);
          }
        }
      }
      if (window.innerWidth < 768) {
  var filterBlocks = document.querySelectorAll('.wizzy-filters-facet-block');
  var filterBlockss = document.querySelectorAll('.wizzy-facet-head');

  filterBlockss.forEach(function (block, index) {
    block.addEventListener('click', function () {
      if (block.classList.contains('collapsed')) {
        // Collapse all headers
        filterBlockss.forEach(function (el) {
          el.classList.add('collapsed');
        });
        // Collapse all content blocks
        filterBlocks.forEach(function (el) {
          el.classList.add('collapsed');
        });

        // Open the clicked one
        block.classList.remove('collapsed');
        filterBlocks[index].classList.remove('collapsed');
      } else {
        // Collapse this one
        block.classList.add('collapsed');
        filterBlocks[index].classList.add('collapsed');
      }
    });
  });
}

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {

      if (window.innerWidth > 768) {
        const sortWrapper = document.querySelector('.search-filters-top-wrapper .wizzy-search-sort-wrapper');
        if (sortWrapper) {
          const sortWrapperClone = sortWrapper.cloneNode(true);
          const sortInFiltersWrapper = document.querySelector('.wizzy-search-filters-left .wizzy-sort-desktop');
  
          if (sortWrapperClone && sortInFiltersWrapper) {
            sortInFiltersWrapper.innerHTML = "";
            sortInFiltersWrapper.appendChild(sortWrapperClone);
          }
        }
      }
      const currentPath = window.location.pathname;
      const navLinks = document.querySelectorAll('nav.header__inline-menu .list-menu__item');
    
      let matchedNavItem = null;
    
      navLinks.forEach(link => {
        var tempLink = link.getAttribute("onclick").match(/'([^']+)'/)[1];
        if (tempLink === currentPath) {
          matchedNavItem = link;
        }
      });

      if (!matchedNavItem) {
        var tempChildLinks = document.querySelectorAll('nav.header__inline-menu .mega-menu__content .mega-menu__link.link');

        if (tempChildLinks) {
          tempChildLinks.forEach(link => {
            var tempLink = link.getAttribute("href");
            if (tempLink === currentPath) {
              matchedNavItem = link;
            }
          });
        }
      }

      if (matchedNavItem) {
        var parentNavItem = matchedNavItem.closest('details.mega-menu');
        if (parentNavItem) {
          var childNavItems = parentNavItem.querySelector('.mega-menu__content');
          if (childNavItems) {
            var categoryFilterWrapper = document.querySelector('.wizzy-facet-body.facet-body-product_main_category_custom');
            if (categoryFilterWrapper) {
              categoryFilterWrapper.innerHTML = childNavItems.innerHTML;
            }
          }
        }
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      //console.log("Wizzy AFTER_PRODUCTS_TRANSFORMED" ,data);
      data.forEach(product => {
        // console.log("Wizzy product id", product.id);
        // console.log("Wizzy product singleVarientGroupId", product.singleVarientGroupId);
        product.handle = product.url.split('/').pop();
        product.inStock = product.inStock;
        const productIdc = window.variantID.split(",");
        const productId = product.id.toString();
        const matched = productIdc.find(id => id.startsWith(productId + "-"));
        if (matched) {
            const quantity1 = matched.split("-")[1];
            product.hideAddButton = "true"; 
            product.defaultQty = quantity1;
          }
        //console.log("product.attributes", product.attributes);
        product.attributes.forEach(attribute => {
          if(attribute.id === "product_product_swatch_custom"){
            product.packSizes = attribute.values[0].value[0];
          }
          if(attribute.id === "product_size_custom"){
            product.capacityUnit = attribute.values[0].value[0];
          }
          if(attribute.id === "product_max_quantity_custom"){
            product.maxQuantity = attribute.values[0].value[0];
          }
          if(attribute.id === "product_veg_nonveg_custom"){
            if(attribute.values[0].value[0] == 'Non Veg'){
              product.vegOrNonVeg = 'non-veg-box';
            }else{
              product.vegOrNonVeg = 'veg-box';
            }
          }
          if(attribute.id === "product_stock_quantity"){
            var productQuantity = attribute.values[0].value[0];
            if (productQuantity < product.maxQuantity) {
              product.maxQuantity = productQuantity;
            }
          }
          if (attribute.id === "product_tags") {
            var rawTags = attribute.values[0].value[0]; // first string from array
            var tagsArray = rawTags.split(",").map(tag => tag.trim()); // split & clean

            if (tagsArray.includes("SC_india")) {
              product.IndiaTagAvailable = true;
            } else {
              product.IndiaTagAvailable = false; // optional
            }

            console.log("Parsed tags:", tagsArray);
          }

        });
      });
      return data;
    }, 1
  );


  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
        $('body').addClass('wizzy-search-results-rendered');
      return data;
    }
  );

};
